<template>
  <v-dialog
    v-model="dialog"
    :persistent="dialog"
    :overlay="false"
    scrollable
    max-width="600px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row v-if="data.length">
            <v-col
              v-for="(d, i) in data"
              :key="i"
              cols="12"
            >
              <VueJsonPretty
                :data="d"
              />
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12">
              <VueJsonPretty
                :data="data"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="$emit('close')"
        >
          {{ $t('general.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'

export default {
  name: 'MetaModal',
  components: { VueJsonPretty },
  props: {
    title: {
      type: String,
      required: true,
      default: null
    },
    data: {
      type: Object || Array,
      required: true,
      default: {}
    },
    dialog: {
      type: Boolean,
      required: true,
      default: false
    }
  }
}
</script>

<style>

</style>